import { ThemeUICSSObject, focusOutline, spacing } from '@apia/theme';
/* IMPORT HERE */

const primary: ThemeUICSSObject = {
  /* PREPEND HERE */
  position: 'relative',
  '[role="tree"]:focus': {
    outline: 'none',

    '.focus': focusOutline,
  },

  '.tree__searchLabelBox': {
    alignItems: 'center',
    borderRadius: '2px',
    display: 'flex',
    float: 'right',
    gap: spacing(3),
    justifyContent: 'center',
    position: 'sticky',
    right: '4px',
    top: '4px',
    transform: 'translateX(0)',
    width: '100%',
    zIndex: 'stickyElements',

    '.tree__loading': {
      position: 'fixed',
      top: 0,
      right: '4px',
      background: 'palette.background.paper',
    },

    button: {
      cursor: 'pointer',
    },
  },

  '.tree__searchLabel': (theme) => ({
    alignItems: 'center',
    display: 'flex',
    gap: spacing(3),
    justifyContent: 'center',
    position: 'fixed',
    p: '2px 5px',
    right: 0,
    top: 0,

    ...theme.palette.getOneState(
      { backgroundColor: 'palette.background.paper' },
      'selected',
    ),
  }),

  '[role="treeitem"]': {
    '&[aria-expanded="false"] ul': {
      display: 'none',
    },

    '&[aria-selected="true"] > .tree__nodeItemLabel': (theme) =>
      theme.palette.getOneState(
        { backgroundColor: 'palette.background.paper' },
        'selected',
      ),
  },

  '.tree__nodeItemLabel': {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: 3,
    alignItems: 'center',

    '& > *:not(.tree__nodeItemLabelRenderer)': {
      flexShrink: 0,
    },
  },

  '.spacer': {
    borderLeft: '1px solid',
    borderLeftColor: 'palette.border.section',
    width: '20px',
    alignSelf: 'stretch',
  },
};

export default primary;
